module.exports = __webpack_public_path__ + "img/slate.4274c8ed.png";